/**
 *
 */
(function(window) {
    'use strict';

    const VvGeneralSrvc = function($http, CONSTANTS) {
        this.getAnagrafica = (ndg) => {
            return $http({
                method: 'GET',
                url: `${CONSTANTS.REST_ROOT}${CONSTANTS.REST.ANAGRAFICA.RECUPERA}/${ndg}`
            });
        };

        this.getAnagraficaPromotore = (ndg) => {
            return $http({
                method: 'GET',
                url: `${CONSTANTS.REST_ROOT}${CONSTANTS.REST.ANAGRAFICA.PROMOTORE}/${ndg}`
            });
        };

        this.convertDate = (toConv) => {
            if (!toConv || toConv.length !== 8) {
                return;
            }

            return new Date(
                toConv.substring(0, 4),
                parseInt(toConv.substring(4, 6)) - 1,
                toConv.substring(6)
            );
        };
    };

    VvGeneralSrvc.$inject = ['$http', 'Mitom_CONSTANTS'];

    angular
        .module('cbl.mitomanager.wa')
        .service('MitomGenralSrvc', VvGeneralSrvc);
})(window);